import { Dispatcher } from "@/Common/Stores/Actions/ActionDispatcher";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

class Listener {
    private dispatcher: Dispatcher<any>;
    private handles: { [operation: number]: (request: LocalEvent) => void } = {};
    private callbackId: string;

    private get isRegistered(): boolean {
        return this.callbackId != null;
    }

    constructor(dispatcher: Dispatcher<any>) {
        this.dispatcher = dispatcher;
    }

    public register(): string {
        if (this.isRegistered == true)
            return;

        this.callbackId = this.dispatcher.register(
            (request: LocalEvent) => {
                let handle = this.handles[request.Operation];
                handle && handle(request);
            }
        );

        return this.callbackId;
    }

    public unregister(): void {
        if (this.isRegistered == true) {
            this.dispatcher.unregister(this.callbackId); // dispo on first handler
            this.callbackId = null;
        }
    }
    public AddHandle(operation: number, handle: (request: LocalEvent) => void): void {
        if (handle && !Object.keys(this.handles).any())
            this.register(); // register on first handler

        if (Object.keys(this.handles).contains(operation))
            throw "Operation already registered";

        this.handles[operation] = handle;
    }
}

export { Listener };
